var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useMemo } from 'react';
import InformationColumn from './micros/InformationColumn/Index';
import ListFeaturesColumn from './micros/ListFeaturesColumn/Index';
import runAndCreateTimeline from './animations/index';
import { sampleData } from '../../components/HoverNumberedList/data';
import './HoverNumberedList.scss';
import useViewport from '../../hooks/useViewport';
export var HoverNumberedList = function (_a) {
    var _b = _a.data, data = _b === void 0 ? sampleData : _b;
    var mainTitleText = data.defaultMainTitleText.value;
    var withAnimation = data.withAnimation || true;
    var listFeaturesArray = data && data.mockListFeaturesArray;
    var _c = useState(null), activeContentInformation = _c[0], setActiveContentInformation = _c[1];
    var _d = useState(null), itemActiveFromMobile = _d[0], setActivationFromMobile = _d[1];
    var _e = useState(false), isFirstTimelineCompleted = _e[0], setIsFirstTimelineCompleted = _e[1];
    var isFunctionallityReady = useMemo(function () { return !withAnimation || isFirstTimelineCompleted; }, [isFirstTimelineCompleted, withAnimation]);
    var rightColumnRef = useRef(null);
    var leftTextColumnRef = useRef(null);
    var mainElementTriggerRef = useRef(null);
    var leftColumnRef = useRef(null);
    var visualViewport = useViewport().visualViewport;
    var isMobile = visualViewport.width < 768;
    var isTablet = visualViewport.width < 1024 && visualViewport.width >= 768;
    var isDesktop = visualViewport.width >= 1024;
    var handleActiveContentInformation = function (newStateValue) {
        if (isFunctionallityReady) {
            setActiveContentInformation(newStateValue);
        }
    };
    var handleActiveFromMobile = function (newStateValue) {
        setActivationFromMobile(newStateValue);
    };
    useEffect(function () {
        if (withAnimation) {
            runAndCreateTimeline({
                rightColumnRef: rightColumnRef,
                mainElementTriggerRef: mainElementTriggerRef,
                leftTextColumnRef: leftTextColumnRef,
                setIsFirstTimelineCompleted: setIsFirstTimelineCompleted,
            });
        }
    }, []);
    return (_jsx("div", __assign({ className: "jobs relative snap-start", ref: mainElementTriggerRef, style: {
            paddingTop: '0px',
            paddingBottom: "" + (isDesktop ? "128px" : isTablet ? "80px" : isMobile ? "64px" : ''),
        } }, { children: _jsxs("div", __assign({ className: "justify-center px-6 md:px-20 lg:flex lg:px-0" }, { children: [_jsx(InformationColumn, { setActivationFromMobile: handleActiveFromMobile, itemActiveFromMobile: itemActiveFromMobile, mainTitleText: mainTitleText, nativeLeftTitleRef: leftTextColumnRef, nativeLeftColumnRef: leftColumnRef, activeContentItem: activeContentInformation }, void 0),
                _jsx(ListFeaturesColumn, { nativeMainRef: rightColumnRef, setActivationFromMobile: handleActiveFromMobile, itemActiveFromMobile: itemActiveFromMobile, activeContentInformation: activeContentInformation, listFeaturesArray: listFeaturesArray, setActiveContentInformation: handleActiveContentInformation }, void 0)] }), void 0) }), void 0));
};
